import TerminatedClientsList from "../components/TerminatedClientsList/TerminatedClientsList";

export default function TerminatedClientsPage() {
    return <TerminatedClientsList />;
}
